import {SidebarDeployments as DeploymentsComponent} from '@github-ui/code-view-sidebar/components/SidebarDeployments'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'

interface Props {
  ownerLogin: string
  repoName: string
  maxToShow?: number
}

export function SidebarDeployments({ownerLogin, repoName, maxToShow}: Props) {
  const {deployments} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!deployments) return null
  return <DeploymentsComponent {...deployments} maxToShow={maxToShow} />
}
